import React from 'react';
import './ManageProducts.css';

function Pagination({ currentPage, totalPages, onPageChange }) {
  // Calculate which page numbers to show
  const getPageNumbers = () => {
    const delta = 2; // Number of pages to show on each side of current page
    const range = [];
    const rangeWithDots = [];
    
    for (let i = Math.max(2, currentPage - delta); 
         i <= Math.min(totalPages - 1, currentPage + delta); 
         i++) {
      range.push(i);
    }
    
    if (currentPage - delta > 2) {
      rangeWithDots.push(1, '...');
    } else {
      rangeWithDots.push(1);
    }
    
    rangeWithDots.push(...range);
    
    if (currentPage + delta < totalPages - 1) {
      rangeWithDots.push('...', totalPages);
    } else if (totalPages > 1) {
      rangeWithDots.push(totalPages);
    }
    
    return rangeWithDots;
  };
  
  const pageNumbers = getPageNumbers();
  
  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };
  
  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };
  
  const handlePageClick = (page) => {
    if (page !== '...' && page !== currentPage) {
      onPageChange(page);
    }
  };
  
  if (totalPages <= 1) {
    return null;
  }
  
  return (
    <div className="paginationContainer">
      <div className="paginationInfo">
        <span>
          Page {currentPage} of {totalPages}
        </span>
      </div>
      
      <div className="paginationControls">
        {/* Previous Button */}
        <button
          onClick={handlePrevious}
          disabled={currentPage === 1}
          className={`paginationButton previousButton ${
            currentPage === 1 ? 'disabled' : ''
          }`}
          aria-label="Previous page"
        >
          <span className="buttonIcon">‹</span>
          Previous
        </button>
        
        {/* Page Numbers */}
        <div className="pageNumbers">
          {pageNumbers.map((page, index) => (
            <button
              key={index}
              onClick={() => handlePageClick(page)}
              className={`pageButton ${
                page === currentPage ? 'activePage' : ''
              } ${
                page === '...' ? 'dotsButton' : ''
              }`}
              disabled={page === '...'}
              aria-label={page === '...' ? 'More pages' : `Go to page ${page}`}
              aria-current={page === currentPage ? 'page' : undefined}
            >
              {page}
            </button>
          ))}
        </div>
        
        {/* Next Button */}
        <button
          onClick={handleNext}
          disabled={currentPage === totalPages}
          className={`paginationButton nextButton ${
            currentPage === totalPages ? 'disabled' : ''
          }`}
          aria-label="Next page"
        >
          Next
          <span className="buttonIcon">›</span>
        </button>
      </div>
    </div>
  );
}

export default Pagination;
